import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import Barcode from '../../../../assets/images/barcode.png'
import { Tag, Tooltip } from 'antd'
import { mappingLineShip } from '../ParentRow';

class LabelShipCol extends React.PureComponent {
    _filterShippingCarrierByClick = (name, value) => {
        const {onChangeFilter, filter} = this.props

        if (typeof onChangeFilter !== 'function') return;
        onChangeFilter({...filter, [name]: [value]})
    }

    render() {
        const {
            handleDeleteLabel,
            multiLabel,
            hasLabel,
            orderLabelDetails,
            labelDetails,
            gen_at,
            box_id,
            shipped_at,
            shipped_ip,
            nextBoxItem = {},
            production_status,
            trackingUrl,
            splitFBAItemLabel,
            handleClickOpenImageItemLabel,
            orderType,
            tags,
            packaged_at,
            barcodeNumber,
            sub_status,
            meta
        } = this.props
        const { partnerTrackingNumber, url, 'created': track_created } = Object.assign({}, labelDetails)
        const {
            'partnerTrackingNumber': orderTrackingNumber,
            'url': orderTrackingUrl,
            'created': orderTrackingCreated
        } = Object.assign({}, { 'partnerTrackingNumber': '' }, orderLabelDetails)
        const timeGenTracking = track_created ? new Date(track_created).toLocaleString('en-GB') : ''
        const timeGenOrderTracking = (orderTrackingCreated || gen_at) ? new Date(orderTrackingCreated || gen_at).toLocaleString('en-GB') : ''
        const shippedAt = shipped_at ? new Date(shipped_at).toLocaleString('en-GB') : ''
        const shippedIp = shipped_ip || ''
        const ffstatus = (orderLabelDetails !== undefined && orderLabelDetails.hasOwnProperty('syncff')) ? orderLabelDetails.syncff : ''
        const lineShip = mappingLineShip(orderLabelDetails && orderLabelDetails.shipping_carrier) || {}

        return (
            <div className="notDisableCancel SyncTracking Labels">
                {
                    orderTrackingNumber &&
                    <React.Fragment>
                        <a href={orderTrackingUrl} target='_blank' rel="noopener noreferrer" className='mr-1'>
                            {orderTrackingNumber}
                        </a>

                        <Tooltip title="Sync Fulfill Status">
                            <i className={`icon-loop3 mr-1 sync-ff ${ffstatus}`} />
                        </Tooltip>

                        <Tooltip title="Xem Label Tracking">
                            <a href={trackingUrl || ''}
                                target='_blank'
                                rel="noopener noreferrer">
                                <i className='icon-new-tab mr-1' />
                            </a>
                        </Tooltip>

                        {!(meta && meta.label) &&
                            <Tooltip title="Xóa Tracking">
                                <i className='icon-cancel-square text-danger cursor-pointer' onClick={handleDeleteLabel} />
                            </Tooltip>
                        }

                        <br />
                        <span title="Label created at">{timeGenOrderTracking}</span>
                        {lineShip && lineShip.name &&
                            <div className='lineShip'>
                                <span>Line ship: <span className='font-weight-bold cursor-pointer hover-underline' onClick={() => this._filterShippingCarrierByClick('shipping_carrier', lineShip.value)}>{lineShip.name}</span></span>
                            </div>
                        }
                    </React.Fragment>
                }
                {
                    shippedAt && <div className="text-muted font-size-sm">
                        <span className="badge badge-mark border-success mr-1" />
                        {shippedAt}
                    </div>
                }
                {
                    shippedIp &&
                    <div className="text-muted font-size-sm">
                        <span className="badge badge-mark border-danger mr-1" />
                        {shippedIp}
                    </div>
                }
                {
                    box_id &&
                    <div>
                        <div>Số thùng: {box_id} <Link to={'/boxes/' + box_id}>Xem thùng</Link></div>
                    </div>
                }
                {
                    production_status === 'packaged' && sub_status === 'manual-package' &&
                    <span className='cursor-pointer' style={{ color: '#2196f3' }} onClick={() => { window.open(`/next-items?barcode=${barcodeNumber}_1`, '_blank') }}>Tìm thùng</span>
                }
                {
                    multiLabel && hasLabel && partnerTrackingNumber &&
                    <React.Fragment>
                        <a href={url} target='_blank' rel="noopener noreferrer">{partnerTrackingNumber}</a>&nbsp;
                        <a href={`https://webtrack.dhlglobalmail.com/?trackingnumber=${partnerTrackingNumber}`}
                            target='_blank' rel="noopener noreferrer"><i className='icon-new-tab' /></a>
                        <br /><span>{timeGenTracking}</span>
                    </React.Fragment>
                }
                {
                    ((!!nextBoxItem.created || !!packaged_at) && production_status === 'packaged') && <div className="text-muted font-size-sm">
                        <span className="badge badge-mark border-primary mr-1" />
                        {
                            !!nextBoxItem.created ? new Date(nextBoxItem.created).toLocaleString('en-GB') :
                                !!packaged_at ? new Date(packaged_at).toLocaleString('en-GB') : ''
                        }
                    </div>
                }

                {
                    orderType && orderType === 'FBA' && splitFBAItemLabel &&
                    <div className="ImageBarcode">
                        <img src={Barcode} alt="barcode" onClick={handleClickOpenImageItemLabel} />
                    </div>
                }

                {
                    !!tags && tags.includes("llc-labelled") &&
                    <Tag color="#108ee9">LLC labelled</Tag>
                }

            </div>
        )
    }
}

LabelShipCol.propTypes = {
    trackingUrl: PropTypes.string,
    multiLabel: PropTypes.bool.isRequired,
    hasLabel: PropTypes.bool.isRequired,
    labelDetails: PropTypes.object,
    orderLabelDetails: PropTypes.object,
    gen_at: PropTypes.string,
    box_id: PropTypes.any,
    boxed_at: PropTypes.string,
    shipped_at: PropTypes.string,
    shipped_ip: PropTypes.string,
    handleDeleteLabel: PropTypes.func.isRequired,
    shipmentCode: PropTypes.string
}

export default LabelShipCol
